// @flow
import styled from "styled-components";

export const Blog = styled.div`
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 900px;

    @media only screen and (min-width: 768px) {
    }
`;

export const Content = styled.div`
    min-height: 800px;
`;

export const Image = styled.div`
    width: 80%;
    max-width: 500px;
`;

export const TitleImage = styled.img`
    background-size: cover;
    background-position: center 32%;
    background-repeat: no-repeat;
    height: 350px;
    width: 100%;
    display: block;
`;

export const TitleMap = styled.div`
    width: 140px;
    height: 140px;
    background-color: #333;
    background-position: center;
    border-radius: 150px;
    left: -50%;
    bottom: 100px;
    position: relative;
    border: solid 2px #fff;
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        width: 300px;
        height: 300px;
        bottom: 182px;
        border: solid 4px #fff;
    }
`;

export const Summary = styled.div`
    border-bottom: 1px solid #dddfe2;
    width: 100%;
    background-color: #fff;
    padding: 50px 0 20px 0;
`;

export const Title = styled.div`
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    color: #444444;
`;

export const Description = styled.div`
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    max-width: 850px;

    @media only screen and (min-width: 768px) {
    }
`;

export const Links = styled.div`
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
    max-width: 850px;
    margin-top: 15px;

    @media only screen and (min-width: 768px) {
    }

    & > a {
        color: inherit;
        font-size: 14px;
        opacity: 0.5;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const Footer = styled.div`
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0;
    text-align: left;
    position: relative;
    padding-bottom: 16px;
`;

export const DataCell = styled.div`
    display: inline-block;
    vertical-align: top;
    height: 24px;
    line-height: 24px;
    padding-left: 16px;
    padding-top: 16px;
`;

export const DataCellText = styled.div`
    display: inline-block;
    vertical-align: top;
    padding-left: 4px;
`;

export const Icon = styled.a`
    color: #ccc;
    display: inline-block;
`;

export const NoBlogs = styled.div`
    text-align: center;
    padding: 20px;
`;

export const Feedback = styled.div`
    position: fixed;
    height: 100vh;
    opacity: 0.4;
    right: 20px;
    bottom: 20px;
    top: 0;
    right: 0;

    &:hover {
        opacity: 1;
    }

    @media only screen and (max-width: 1090px) {
        display: none;
    }
`;

export const PageLink = styled.a`
    cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/home-page-view/styled.js